import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { platformAPI } from '../lib/platformApi';

const PlatformContext = createContext(null);

export function PlatformProvider({ children }) {
  const [tenant, setTenant] = useState(() => {
    const str = localStorage.getItem('platform_tenant');
    return str ? JSON.parse(str) : {};
  });
  const [stats, setStats] = useState(null);
  const [wallets, setWallets] = useState([]);
  const [walletsTotal, setWalletsTotal] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [transactionsTotal, setTransactionsTotal] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const [statsRes, walletsRes, txnRes] = await Promise.all([
        platformAPI.getDashboardStats(),
        platformAPI.getWallets({ limit: 200 }),
        platformAPI.getTransactions({ limit: 100 }),
      ]);
      setStats(statsRes.data);
      setWallets(walletsRes.data.wallets || []);
      setWalletsTotal(walletsRes.data.total || 0);
      setTransactions(txnRes.data.transactions || []);
      setTransactionsTotal(txnRes.data.total || 0);
      // Update tenant info from stats if available
      if (statsRes.data?.tenant) {
        setTenant(prev => ({ ...prev, ...statsRes.data.tenant }));
      }
    } catch { /* auth interceptor handles 401 */ }
    setLoaded(true);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const updateTenant = (data) => {
    setTenant(data);
    localStorage.setItem('platform_tenant', JSON.stringify(data));
  };

  const updateWallet = (walletId, updates) => {
    setWallets(prev => prev.map(w => w.wallet_id === walletId ? { ...w, ...updates } : w));
  };

  return (
    <PlatformContext.Provider value={{ tenant, updateTenant, stats, wallets, walletsTotal, transactions, transactionsTotal, loaded, refresh, updateWallet }}>
      {children}
    </PlatformContext.Provider>
  );
}

export function usePlatform() {
  const ctx = useContext(PlatformContext);
  if (!ctx) throw new Error('usePlatform must be inside PlatformProvider');
  return ctx;
}
